import { getKeys } from './get-keys';

export function getEntries<TObject extends Record<string, unknown>>(
    object: TObject,
): Array<[keyof TObject & string, TObject[keyof TObject]]> {
    return getKeys(object).map(key => [key, object[key]] as [keyof TObject & string, TObject[keyof TObject]]);
}
